module.exports = __webpack_public_path__ + "img/icon_logout.4c4c393d.svg";